module.exports = __webpack_public_path__ + "img/ss_about copy.96949d13.png";